import { cva, VariantProps } from 'class-variance-authority'
import { ClassValue } from 'tailwind-ui'
import { cn } from '../helpers/classnames'

export interface SpinnerProps
  extends React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >,
    VariantProps<typeof loadingVariants> {}

export const loadingVariants = cva('w-6 h-6', {
  variants: {
    variant: {
      primary: ['text-white'],
      outline: [],
      ghost: [],
      light: ['text-black'],
      dark: ['text-white'],
      default: ['fill-primary-500'],
      ghost_default: ['!text-gray-300 dark:!text-gray-700 fill-stampede-500'],
      link: ['fill-primary-500'],
      warning: ['fill-warning-500'],
    },
    brandKit: {
      true: ['!fill-interface-800 !text-interface-50'],
      false: [],
    },
    size: {
      xs: 'h-3 w-3',
      sm: 'h-4 w-4',
      base: 'h-5 w-5',
      lg: 'h-5 w-5',
      xl: 'h-8 w-8',
    },
  },
  // size: {
  //   sm: 'h-4 w-4',
  //   base: 'h-5 w-5',
  //   lg: 'h-6 w-6',
  //   xl: 'h-8 w-8',
  // }
  defaultVariants: {
    variant: 'default',
    // size: 'base',
  },
})

export function Spinner({
  variant,
  className,

  size,
  brandKit = true,
  ...props
}: SpinnerProps) {
  return (
    <svg
      aria-hidden="true"
      fill="currentColor"
      className={cn(
        'inline animate-spin',
        loadingVariants({ variant, brandKit, size }),
        className
      )}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="3 3 18 18"
      {...props}
    >
      <path
        className="opacity-20"
        d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
      ></path>
      <path d="M16.9497 7.05015C14.2161 4.31648 9.78392 4.31648 7.05025 7.05015C6.65973 7.44067 6.02656 7.44067 5.63604 7.05015C5.24551 6.65962 5.24551 6.02646 5.63604 5.63593C9.15076 2.12121 14.8492 2.12121 18.364 5.63593C18.7545 6.02646 18.7545 6.65962 18.364 7.05015C17.9734 7.44067 17.3403 7.44067 16.9497 7.05015Z"></path>
    </svg>
  )
}
